import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import _ from 'lodash';
import dayjs from 'dayjs';
import { GetExpirationsUrl, GetStrikesUrl, GetChainUrl } from '../constants';
import { formatExpiration } from '../utilities/DateUtilities';
import { DateFormats } from '..';
export var getExpirations = function getExpirations(api) {
  return function (symbol) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var res, expDates;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.get(GetExpirationsUrl, {
                underlyingSymbol: symbol,
                isExpanded: 'true'
              });

            case 2:
              res = _context.sent;
              expDates = _.map(res.payload ? res.payload : [], function (d) {
                return Object.assign({}, d, formatExpiration(d));
              });
              return _context.abrupt("return", {
                responseCode: res.responseCode,
                payload: expDates
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
export var getStrikes = function getStrikes(api) {
  return function (symbol, expiration, time, strikeMin, strikeMax) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var expirations;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return api.get(GetStrikesUrl, {
                underlyingSymbol: symbol,
                expiration: dayjs(expiration).format(DateFormats.ApiFormat),
                strikeMin: strikeMin,
                strikeMax: strikeMax,
                time: time
              });

            case 2:
              expirations = _context2.sent;
              return _context2.abrupt("return", expirations);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};
export var getChain = function getChain(api) {
  return function (symbol, expiration, strikeCount, fetchGreeks) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var underlyingSymbol, strikeParams, chainData, chainDataResults;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // if strike count == 0, fetch all strikes
              underlyingSymbol = symbol;
              strikeParams = strikeCount === 0 ? {} : {
                strikesAroundMarket: strikeCount / 2
              };
              _context3.next = 4;
              return api.get(GetChainUrl, Object.assign({
                underlyingSymbol: underlyingSymbol,
                expiration: dayjs(expiration).format(DateFormats.ApiFormat),
                // pass date part only without time
                fetchGreeks: fetchGreeks
              }, strikeParams));

            case 4:
              chainData = _context3.sent;
              chainDataResults = _(chainData.payload).reduce(function (pairs, expirations, opsymbol) {
                var expirationStrikes = _(expirations).flatMap(function (exp) {
                  return _.flatMap(exp);
                }).map(function (e) {
                  return Object.assign({}, e, {
                    symbol: opsymbol,
                    underlyingSymbol: underlyingSymbol
                  });
                }).value();

                return _.union(pairs, expirationStrikes);
              }, []);
              return _context3.abrupt("return", {
                data: _.sortBy(chainDataResults, function (op) {
                  return op.Strike;
                }),
                responseCode: chainData.responseCode
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };
};
export var options = function options(api) {
  return {
    expirations: getExpirations(api),
    strikes: getStrikes(api),
    optionchain: getChain(api)
  };
};